//#region IMPORT
import React, { useEffect, useState } from 'react';
import M_TBM_CUSTOM_01 from './M_TBM_CUSTOM_01';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { useDelete1 } from './M_TBM_CUSTOM_01_Query';
import { useDelete } from '../../../../Hooks/useDelete';
import { useBackStack } from '../../../../Hooks/back/useBackStack';
//#endregion

function M_TBM_CUSTOM_01F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const bottomSheetState = useSelector((state) => state.bottomSheet);

  const [imageFile, setImageFile] = useState({
    mapFiles: '',
    mapImage: '',
  });
  //#endregion

  // 스택형 뒤로가기로 변경: TBM 시작 단계 이탈 시 확인 시트 표시
  useBackStack({
    type: 'sheet',
    enabled: !bottomSheetState.bottom,
    onBack: () =>
      dispatch(BottomSheetActions.OpenBottomSheet({ type: 'backClickTbmEm' })),
  });

  //#region 이벤트
  useEffect(() => {
    return () => {
      dispatch(BottomSheetActions.CloseBottomSheet());
    };
  }, [dispatch]);
  //#endregion

  //#region 쿼리
  const { runAsync: Delete1Async } = useDelete1();

  // 삭제
  const { run: Delete1 } = useDelete({
    menuId: 'M_TBM_CUSTOM_01',
    requestDelete: (rows) => Delete1Async({ tbmCd: props.tbmCdRef.current }),
  });
  //#endregion

  return (
    <div className="wrap">
      <M_TBM_CUSTOM_01
        userInfo={userInfo}
        imageFile={imageFile}
        setImageFile={setImageFile}
        setModalToggle1={props.setModalToggle1}
        modalToggle1={props.modalToggle1}
        setModalToggle2={props.setModalToggle2}
        modalToggle2={props.modalToggle2}
        activeStep={activeStep}
        setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
        userCount={props.userCount}
        setUserCount={props.setUserCount}
        DeleteLogic1={Delete1}
        ActiveButton={props.ActiveButton}
      />
    </div>
  );
}

export default M_TBM_CUSTOM_01F;
